module.exports = __webpack_public_path__ + "static/media/nescafe-ss.bb5e693f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/nescafe-ss.png
 ** module id = 208
 ** module chunks = 0
 **/